import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl, InputLabel } from '@mui/material';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { useSelectWithCheckboxesOnChange } from '../../../../../../shared/components/base-select-with-checkboxes/hooks/use-select-with-checkboxes-on-change/use-select-with-checkboxes-on-change.hook';
import { WithOptionsModel } from '../../../../../../shared/components/with-options/models/with-options.model';
import withPlatformOptions from '../../../../../../shared/components/with-platform-options/with-platform-options';
import { AppsFilters } from '../../../../models/apps-filters.model';
import { filterAppsByPlatforms } from '../../../../store/slices/apps.slice';
import { AppsFilterProps } from '../../types/apps-filter-props.type';
import { withAppsFilterValues } from '../with-apps-filter-values';

const PlatformsDropdown: FunctionComponent<
  AppsFilterProps & WithOptionsModel
> = (
  props: PropsWithChildren<AppsFilterProps & WithOptionsModel>
): ReactElement => {
  const {
    selectedAppFilters: { platforms: selectedPlatformIds },
    setFieldValue,
    options,
  } = props;

  const selectedPlatformsMapped = options
    .filter(item => selectedPlatformIds?.includes(item.id))
    .map(item => item.id);

  const onChange = useSelectWithCheckboxesOnChange<AppsFilters>(
    'platforms',
    setFieldValue,
    filterAppsByPlatforms
  );

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="apps-platforms"
      variant="filled"
    >
      <InputLabel id="multiple-checkbox-label-platforms">Platforms</InputLabel>

      <BaseSelectWithCheckboxes
        id="platforms"
        name="platforms"
        onChange={onChange}
        selectOptions={options}
        clearMultiSelectFilterAction={filterAppsByPlatforms}
        value={selectedPlatformsMapped ?? []}
      />
    </FormControl>
  );
};

export default withAppsFilterValues(withPlatformOptions(PlatformsDropdown));
